import type { SVGProps } from 'react'
const SvgSySupport = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12 1.4C6.2 1.4 1.5 6.1 1.5 12v4.4c0 1.1.9 2 2.1 2h1.1c.6 0 1.1-.5 1.1-1.1v-5.4c0-.6-.5-1.1-1.1-1.1h-1c.6-4.1 4.1-7.3 8.4-7.3s7.8 3.2 8.4 7.3h-1c-.6 0-1.1.5-1.1 1.1v6.5c0 1.2-.9 2.1-2.1 2.1h-2.1v-1.1H10v3.2h6.3c2.3 0 4.2-1.9 4.2-4.2 1.2 0 2.1-.9 2.1-2V12c0-5.8-4.7-10.6-10.6-10.6" />
	</svg>
)
export default SvgSySupport
